import { render, staticRenderFns } from "./BuscadorPolizasForm.vue?vue&type=template&id=47a5e795"
import script from "./BuscadorPolizasForm.vue?vue&type=script&lang=js"
export * from "./BuscadorPolizasForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports